import { Mail, MapPin, Phone, Share2, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { useState } from "react";
import { toast } from "sonner";
import { OFundedLogo } from "@/components/BrandLogo";

/* "Share OFunded" cluster — instead of dead Follow-us links, we let
   visitors share the site to their own social. Tap = window.open with
   the appropriate share URL. The native Web Share API is used first
   on mobile so users can share to ANY app installed on their device. */
function ShareCluster() {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const siteUrl = "https://ofunded.com";
  const shareText = "Trade with OFunded — get instantly funded up to $250K with 90% profit split.";

  const networks = [
    { id: "x",         label: "X",          url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(siteUrl)}&text=${encodeURIComponent(shareText)}`, svgKey: "x" },
    { id: "facebook",  label: "Facebook",   url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(siteUrl)}`, svgKey: "fb" },
    { id: "linkedin",  label: "LinkedIn",   url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(siteUrl)}`, svgKey: "li" },
    { id: "whatsapp",  label: "WhatsApp",   url: `https://api.whatsapp.com/send?text=${encodeURIComponent(`${shareText} ${siteUrl}`)}`, svgKey: "wa" },
    { id: "telegram",  label: "Telegram",   url: `https://t.me/share/url?url=${encodeURIComponent(siteUrl)}&text=${encodeURIComponent(shareText)}`, svgKey: "tg" },
    { id: "reddit",    label: "Reddit",     url: `https://www.reddit.com/submit?url=${encodeURIComponent(siteUrl)}&title=${encodeURIComponent("OFunded — Prop Trading Firm")}`, svgKey: "rd" },
    { id: "email",     label: "Email",      url: `mailto:?subject=${encodeURIComponent("Check out OFunded")}&body=${encodeURIComponent(`${shareText}\n\n${siteUrl}`)}`, svgKey: "em" },
  ];

  // Tiny brand SVGs (no Lucide equivalents)
  const Glyph = ({ k }) => {
    switch (k) {
      case "x":  return <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66L13.123 16.4l-5.214 5.35H4.6l7.73-8.835L4.085 2.25h6.83l4.713 6.231 4.617-6.231Zm-1.16 17.52h1.833L7.084 4.126H5.117l11.967 15.643Z"/></svg>;
      case "fb": return <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M22 12.06C22 6.51 17.52 2 12 2S2 6.51 2 12.06c0 5 3.66 9.14 8.44 9.9v-7H7.9v-2.9h2.54V9.85c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7c4.78-.76 8.44-4.9 8.44-9.9Z"/></svg>;
      case "li": return <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.95v5.66H9.36V9h3.4v1.56h.05c.47-.9 1.63-1.85 3.36-1.85 3.59 0 4.25 2.36 4.25 5.44v6.3ZM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12ZM7.12 20.45H3.56V9h3.56v11.45ZM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0Z"/></svg>;
      case "wa": return <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M17.5 14.4c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.6-.91-2.2-.24-.58-.49-.5-.67-.5l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.87 1.21 3.07.15.2 2.09 3.2 5.07 4.48.71.31 1.26.49 1.69.62.71.23 1.36.2 1.87.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35ZM12.04 2.16C6.55 2.16 2.1 6.62 2.1 12.1c0 1.95.57 3.78 1.54 5.32L2 22l4.71-1.6a9.92 9.92 0 0 0 5.33 1.55h.01c5.48 0 9.94-4.46 9.94-9.94 0-2.66-1.04-5.16-2.92-7.04A9.92 9.92 0 0 0 12.04 2.16Zm0 18.13a8.18 8.18 0 0 1-4.18-1.14l-.3-.18-3.1 1.05 1.06-3.03-.19-.31a8.2 8.2 0 0 1-1.26-4.4c0-4.55 3.7-8.25 8.26-8.25 2.2 0 4.27.86 5.83 2.42a8.2 8.2 0 0 1 2.42 5.83c0 4.55-3.71 8.25-8.26 8.25Z"/></svg>;
      case "tg": return <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M9.8 16.7 9.6 20c.5 0 .7-.2 1-.5l2.4-2.3 5 3.7c.9.5 1.5.2 1.8-.8L23 3.6c.3-1.2-.4-1.7-1.3-1.4L1.6 9.8c-1.2.5-1.2 1.1-.2 1.4l5.1 1.6 11.8-7.4c.6-.4 1.1-.2.7.2"/></svg>;
      case "rd": return <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M22 12.07c0-1.22-.99-2.21-2.21-2.21-.6 0-1.13.23-1.53.62-1.49-1.07-3.55-1.77-5.83-1.85l1-4.7 3.27.69c0 .8.65 1.45 1.45 1.45s1.45-.65 1.45-1.45-.65-1.45-1.45-1.45c-.57 0-1.06.33-1.3.81L13.13 3a.36.36 0 0 0-.43.28l-1.11 5.23c-2.32.06-4.41.77-5.92 1.85a2.18 2.18 0 0 0-1.5-.6A2.21 2.21 0 0 0 2 11.97c0 .89.53 1.66 1.29 2-.04.27-.07.55-.07.83 0 3.42 3.97 6.2 8.86 6.2s8.86-2.78 8.86-6.2c0-.28-.03-.56-.07-.83.76-.34 1.29-1.11 1.29-2Z"/></svg>;
      case "em": return <Mail size={14} />;
      default: return null;
    }
  };

  const openShare = async (n) => {
    // Mobile-first: try native Web Share so user can share to ANY app
    if (typeof navigator !== "undefined" && navigator.share && /Mobi|Android/i.test(navigator.userAgent)) {
      try {
        await navigator.share({ title: "OFunded", text: shareText, url: siteUrl });
        return;
      } catch (err) {
        // Web Share API throws AbortError when the user dismisses the
        // native sheet — that's an expected user choice, not an error.
        // Fall through to open the picker URL.
        if (process.env.NODE_ENV !== "production" && err?.name !== "AbortError") {
          console.debug("navigator.share failed:", err);
        }
      }
    }
    window.open(n.url, "_blank", "noopener,noreferrer,width=560,height=620");
  };

  const copyLink = () => {
    navigator.clipboard?.writeText(siteUrl).catch((err) => {
      if (process.env.NODE_ENV !== "production") {
        console.warn("Clipboard write failed:", err);
      }
    });
    setCopied(true);
    toast.success("Site link copied");
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div>
      <div className="text-[10px] uppercase tracking-[0.20em] text-zinc-500 font-semibold mb-3 flex items-center gap-1.5">
        <Share2 size={11} /> {t("footer.shareLabel", "Share OFunded")}
      </div>
      <div className="flex flex-wrap gap-2" data-testid="footer-share-cluster">
        {networks.map((n) => (
          <button
            key={n.id}
            type="button"
            onClick={() => openShare(n)}
            data-testid={`share-${n.id}`}
            aria-label={`Share on ${n.label}`}
            title={`Share on ${n.label}`}
            className="w-9 h-9 rounded-full border border-white/10 hover:border-brand/60 hover:text-brand grid place-items-center text-zinc-400 transition-colors"
          >
            <Glyph k={n.svgKey} />
          </button>
        ))}
        <button
          type="button"
          onClick={copyLink}
          data-testid="share-copy-link"
          aria-label={t("footer.copy_link_aria", "Copy site link")}
          title={t("footer.copy_link", "Copy link")}
          className="w-9 h-9 rounded-full border border-white/10 hover:border-brand/60 hover:text-brand grid place-items-center text-zinc-400 transition-colors"
        >
          {copied ? <Check size={14} className="text-emerald-400" /> : (
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer data-testid="site-footer" className="relative mt-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <Link to="/" className="flex items-center mb-5">
            <OFundedLogo className="h-6 w-auto" />
          </Link>
          <p className="text-zinc-400 text-sm leading-relaxed mb-5">
            {t("footer.tagline")}
          </p>
          <ShareCluster />
        </div>

        <div>
          <h3 className="font-display text-sm font-medium tracking-wider uppercase text-white mb-5">{t("footer.quickLinks")}</h3>
          <ul className="space-y-3 text-sm text-zinc-400">
            <li><Link to="/" data-testid="footer-link-home" className="hover:text-white">{t("nav.home")}</Link></li>
            <li><Link to="/challenges" data-testid="footer-link-challenges" className="hover:text-white">{t("nav.challenges")}</Link></li>
            <li><Link to="/partner" data-testid="footer-link-partner" className="hover:text-white">{t("nav.partner")}</Link></li>
            <li><Link to="/faq" data-testid="footer-link-faq" className="hover:text-white">{t("nav.faq")}</Link></li>
            <li><Link to="/about" data-testid="footer-link-about" className="hover:text-white">{t("nav.about")}</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-white">{t("nav.contact")}</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-medium tracking-wider uppercase text-white mb-5">{t("footer.company")}</h3>
          <ul className="space-y-3 text-sm text-zinc-400">
            <li><Link to="/about" data-testid="footer-link-about-company" className="hover:text-white">{t("nav.about")}</Link></li>
            <li><Link to="/company-news" data-testid="footer-link-news" className="hover:text-white">{t("news.pill", "Company News")}</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-white" data-testid="footer-link-privacy">{t("footer.privacy")}</Link></li>
            <li><Link to="/legal/terms" className="hover:text-white" data-testid="footer-link-terms">{t("footer.terms")}</Link></li>
            <li><Link to="/legal/cookies" className="hover:text-white" data-testid="footer-link-cookies">{t("footer.cookies")}</Link></li>
            <li><Link to="/legal/refund" className="hover:text-white" data-testid="footer-link-refund">{t("footer.refund")}</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-medium tracking-wider uppercase text-white mb-5">{t("footer.getInTouch")}</h3>
          <ul className="space-y-3 text-sm text-zinc-400">
            <li className="flex items-start gap-3"><MapPin size={16} className="text-brand mt-0.5 shrink-0" /><span>Office 3, 3rd floor, One Central, Dubai World Trade Center, Dubai, UAE</span></li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-brand shrink-0" /><a href="mailto:info@ofunded.com" className="hover:text-white">info@ofunded.com</a></li>
            <li className="flex items-center gap-3"><Phone size={16} className="text-brand shrink-0" /><a href="tel:+97143893999" className="hover:text-white">+971 4 389 3999</a></li>
          </ul>
        </div>
      </div>

      <div>
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-8 text-xs text-zinc-500 leading-relaxed space-y-3">
          <p data-testid="footer-disclaimer">
            <strong className="text-zinc-400">{t("footer.disclaimerLabel")}</strong> {t("footer.disclaimer")}
          </p>
          <p>{t("footer.risk")}</p>
          <p className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 pt-3">
            <span>
              <Trans i18nKey="footer.copyright" values={{ year: new Date().getFullYear() }} />
            </span>
            <Link to="/admin/login" data-testid="admin-login-footer-link" className="text-zinc-600 hover:text-brand">{t("footer.admin")}</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
